import React from 'react';
import { T } from './login.theme';
import { COPY } from './login.copy';
import { Dialog, GhostButton, DangerButton } from './LoginControls';

/**
 * Confirm before a tile goes.
 *
 * The wording says exactly how little this destroys — people hesitate over
 * "Remove" when they can't tell whether it deletes the person's account.
 */
export default function RemoveWaiterDialog({ profile, onCancel, onConfirm }) {
  return (
    <Dialog onClose={onCancel} width={340}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, padding: '22px 22px 20px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, paddingRight: 30 }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: T.ink }}>
            {COPY.removeTitle(profile.name || profile.username)}
          </span>
          <span style={{ fontSize: 12.5, color: T.inkSoft, lineHeight: 1.5 }}>
            {COPY.removeBody}
          </span>
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <GhostButton style={{ flex: 1 }} onClick={onCancel}>
            {COPY.keep}
          </GhostButton>
          <DangerButton style={{ flex: 1 }} onClick={() => onConfirm(profile)}>
            {COPY.remove}
          </DangerButton>
        </div>
      </div>
    </Dialog>
  );
}
